import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { Description } from 'components/Typography'
import { NavButton } from 'components/Button'

const DeliveryScheduleDeleteCompleteTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/delete.svg'} alt={'お届け可能日を削除しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          お届け可能日を
          <br />
          削除しました
        </h2>
        <Spacer size={12} />
        <Description
          align={'center'}
          description={
            'sacriを立ち上げて、対象の商品がお届け可能日として選択できなくなっていることを確認してください。'
          }
        />
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'お届け可能日設定に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/schedule/delivery'} />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/order/delivery'} />
      <Spacer size={72} />
    </div>
  )
}

export default DeliveryScheduleDeleteCompleteTemplate
